import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { message, Tooltip, Modal, Input, Select, InputNumber, Button, Affix } from 'antd';
import moment from 'moment';
import {
    FaClock,
    FaDollarSign,
    FaHeart,
    FaRegHeart,
    FaFileAlt,
    FaInfoCircle,
    FaHome,
    FaCheckCircle,
    FaCamera,
    FaStore,
    FaEnvelope,
    FaPhone,
    FaMapMarkerAlt,
    FaUsers,
    FaUser,
    FaHashtag,
    FaFire,
    FaTrophy,
    FaGlobe,
    FaShoppingCart,
    FaShareAlt,
    FaCalendar,
    FaQrcode,
    FaSearch,
    FaFilter,
} from 'react-icons/fa';
import auctionService from '../../services/auctionService';
import pusherService from '../../services/pusherService';
import { useSelector, useDispatch } from 'react-redux';
import favoriteService from '../../services/favoriteService';
import { toggleFavoriteAuction, toggleFavoriteLot } from '../../redux/userSlice';
import env from '../../env';
import VideoPreviewModal from '../VideoPreviewModal';
import CompanyDrawer from '../Common/CompanyDrawer';
import ShareAuctionModal from './ShareAuctionModal';
import AuctionQRCodeModal from './AuctionQRCodeModal';
import ConnectToBidShareButtons from './ConnectToBidShareButtons';
import Breadcrumb from '../Common/Breadcrumb';
import ImageGallery from '../Common/ImageGallery';
import LeafletMap from '../Common/LeafletMap';
import ContactAgentsOwner from '../Common/ContactAgentsOwner';
import AuctionCountdown from '../Common/AuctionCountdown';
import FeaturedActiveAuctions from './FeaturedActiveAuctions';
import './AuctionDetail.css';
import { useIsDesktop } from '../../utils/helpers';
import { startServerTimeSync, getServerNow } from '../../utils/serverTime';


const LotsHeader = ({
    isSearching,
    searchResultsCount,
    lots,
    totalLotsCount,
    searchQuery,
    setSearchQuery,
    statusFilter,
    setStatusFilter,
    minPrice,
    setMinPrice,
    maxPrice,
    setMaxPrice,
    handleSearch,
    handleClearFilters,
  }) => {
    return (
        <div style={{
            background: 'linear-gradient(135deg, rgb(247 247 247) 0%, rgb(251 251 251) 50%, rgb(235 235 235) 100%)',
            borderBottom: '3px solid rgba(255, 255, 255, 0.2)',
            padding: '24px',
            borderRadius: '16px 16px 0 0',
            boxShadow: '0 8px 32px rgba(59, 130, 246, 0.3), 0 4px 16px rgba(0,0,0,0.15)',
            position: 'relative',
            overflow: 'hidden'
        }}>
            {/* Decorative overlay */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.08) 0%, transparent 50%)',
                pointerEvents: 'none'
            }}></div>
            <div style={{ position: 'relative', zIndex: 1 }}>
                <div className="d-flex flex-column">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <div className="rounded-2 p-2 me-3" style={{
                                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                backdropFilter: 'blur(10px)',
                                border: '1px solid rgba(255, 255, 255, 0.3)'
                            }}>
                                <FaShoppingCart style={{ fontSize: '20px', color: '#000' }} />
                            </div>
                            <div>
                                <h5 className="mb-0 fw-bold" style={{ 
                                    color: '#000', 
                                    fontSize: '20px', 
                                    letterSpacing: '-0.3px',
                                    textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
                                }}>
                                    Lots
                                </h5>
                                <small style={{ 
                                    fontSize: '13px',
                                    color: '#000',
                                    textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
                                }}>
                                    {isSearching && searchResultsCount !== null
                                        ? `Showing ${lots.length} of ${searchResultsCount} ${searchResultsCount === 1 ? 'result' : 'results'}`
                                        : `${totalLotsCount} ${totalLotsCount === 1 ? 'lot' : 'lots'} available in this auction`
                                    }
                                </small>
                            </div>
                        </div>
                    </div>
                    
                    {/* Search and Filters Row - Full Width */}
                    <div className="row" style={{
                        margin: 0,
                        borderTop: '1px solid rgba(0, 0, 0, 0.2)',
                        marginTop: '16px',
                        paddingTop: '16px',
                    }}>
                        {/* Search Input - Row 1 on tablet with Status */}
                        <div className="col-12 col-md-6 col-lg-4">
                            <label className="form-label mb-2" style={{
                                fontSize: '12px',
                                fontWeight: '600',
                                color: '#000',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                marginBottom: '8px',
                                textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
                            }}>
                                Search
                            </label>
                        <Input
                            placeholder="Search by title or lot number..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onPressEnter={handleSearch}
                            prefix={<FaSearch style={{ color: '#6b7280' }} />}
                            size="large"
                            style={{
                                borderRadius: '8px',
                                width: '100%',
                                border: '1px solid #d1d5db',
                                transition: 'all 0.2s ease'
                            }}
                            onFocus={(e) => {
                                e.target.style.borderColor = '#3b82f6';
                                e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = '#d1d5db';
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                    </div>
                    
                    {/* Status Filter - Row 1 on tablet with Search */}
                    <div className="col-12 col-md-6 col-lg-2">
                        <label className="form-label mb-2" style={{
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#000',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            marginBottom: '8px',
                            textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
                        }}>
                            Status
                        </label>
                        <Select
                            value={statusFilter}
                            onChange={(value) => setStatusFilter(value)}
                            onPressEnter={handleSearch}
                            size="large"
                            style={{
                                width: '100%',
                                borderRadius: '8px'
                            }}
                            options={[
                                { value: 'all', label: 'All Status' },
                                { value: 'active', label: 'Active' },
                                { value: 'timeout', label: 'Timeout' },
                                { value: 'sold', label: 'Sold' },
                                { value: 'cancelled', label: 'Cancelled' }
                            ]}
                        />
                    </div>
                    
                    {/* Min Price - Row 2 on tablet with Max Price */}
                    <div className="col-12 col-md-6 col-lg-2">
                        <label className="form-label mb-2" style={{
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#000',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            marginBottom: '8px',
                            textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
                        }}>
                            Min Price
                        </label>
                        <InputNumber
                            placeholder="0.00"
                            value={minPrice ? parseFloat(minPrice) : null}
                            onChange={(value) => setMinPrice(value ? value.toString() : '')}
                            onPressEnter={handleSearch}
                            size="large"
                            style={{
                                width: '100%',
                                borderRadius: '8px'
                            }}
                            formatter={(value) => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                            parser={(value) => value ? value.replace(/\$\s?|(,*)/g, '') : ''}
                            min={0}
                            controls={false}
                        />
                    </div>
                    
                    {/* Max Price - Row 2 on tablet with Min Price */}
                    <div className="col-12 col-md-6 col-lg-2">
                        <label className="form-label mb-2" style={{
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#000',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            marginBottom: '8px',
                            textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
                        }}>
                            Max Price
                        </label>
                        <InputNumber
                            placeholder="No limit"
                            value={maxPrice ? parseFloat(maxPrice) : null}
                            onChange={(value) => setMaxPrice(value ? value.toString() : '')}
                            onPressEnter={handleSearch}
                            size="large"
                            style={{
                                width: '100%',
                                borderRadius: '8px'
                            }}
                            formatter={(value) => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                            parser={(value) => value ? value.replace(/\$\s?|(,*)/g, '') : ''}
                            min={0}
                            controls={false}
                        />
                    </div>
                    
                    {/* Action Buttons - Row 3 on tablet, grouped together */}
                    <div className="col-12 col-md-12 col-lg-2">
                        <label className="form-label mb-2" style={{
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#374151',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            marginBottom: '8px',
                            visibility: 'hidden'
                        }}>
                            Actions
                        </label>
                        <div className="d-flex gap-2" style={{ width: '100%' }}>
                            <Button
                                type="primary"
                                onClick={handleSearch}
                                size="large"
                                icon={<FaSearch />}
                                style={{
                                    borderRadius: '8px',
                                    whiteSpace: 'nowrap',
                                    height: '40px',
                                    flex: '1 1 auto',
                                    fontWeight: '600',
                                    boxShadow: '0 2px 4px rgba(59, 130, 246, 0.2)',
                                    transition: 'all 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-1px)';
                                    e.currentTarget.style.boxShadow = '0 4px 8px rgba(59, 130, 246, 0.3)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(59, 130, 246, 0.2)';
                                }}
                            >
                                <span className="d-none d-md-inline">Search</span>
                                <span className="d-md-none">Search</span>
                            </Button>
                            
                            <Button
                                onClick={handleClearFilters}
                                danger
                                size="large"
                                style={{
                                    borderRadius: '8px',
                                    whiteSpace: 'nowrap',
                                    height: '40px',
                                    flex: '1 1 auto',
                                    fontWeight: '600',
                                    boxShadow: '0 2px 4px rgba(220, 38, 38, 0.2)',
                                    transition: 'all 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-1px)';
                                    e.currentTarget.style.boxShadow = '0 4px 8px rgba(220, 38, 38, 0.3)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(220, 38, 38, 0.2)';
                                }}
                            >
                                Clear
                            </Button>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    );
};

// Helper function to format price
const formatPrice = (price) => {
    if (price === null || price === undefined) return '0.00';
    return Number(price).toFixed(2);
};

// Helper function to format currency with PKR
const formatCurrency = (price) => {
    return `PKR ${formatPrice(price)}`;
};


const AuctionDetail = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [auction, setAuction] = useState(null);
    const [lots, setLots] = useState([]);
    const [loading, setLoading] = useState(true);
    const [videoModalVisible, setVideoModalVisible] = useState(false);
    const [companyDrawerVisible, setCompanyDrawerVisible] = useState(false);
    const [shareModalVisible, setShareModalVisible] = useState(false);
    const [qrModalVisible, setQrModalVisible] = useState(false);
    const [agentsModalVisible, setAgentsModalVisible] = useState(false);
    const [countdownCompleted, setCountdownCompleted] = useState(false);
    const countdownCompleteCalled = useRef(false);
    const { currentUser } = useSelector((state) => state.user);

    useEffect(() => {
        startServerTimeSync();
    }, []);

    // Infinite scroll state
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const lotsObserverRef = useRef(null);
    
    // Search and filter state
    const [searchQuery, setSearchQuery] = useState('');
    const [isSearching, setIsSearching] = useState(false);
    const [searchResultsCount, setSearchResultsCount] = useState(null);
    const [statusFilter, setStatusFilter] = useState('all');
    const [minPrice, setMinPrice] = useState('');
    const [maxPrice, setMaxPrice] = useState('');
    const [filtersVisible, setFiltersVisible] = useState(false);
    const [totalLotsCount, setTotalLotsCount] = useState(0);
    
    // Refs for scroll navigation
    const descriptionRef = useRef(null);
    const locationRef = useRef(null);
    const lotsRef = useRef(null);
    const isDesktop = useIsDesktop();
    // Scroll functions
    const scrollToDescription = () => {
        descriptionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    
    const scrollToLocation = () => {
        locationRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    
    const scrollToLots = () => {
        lotsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    useEffect(() => {
        loadAuction();
        // Reset pagination and search state when auction changes
        setCurrentPage(1);
        setHasMore(true);
        setLots([]);
        setSearchQuery('');
        setIsSearching(false);
        setSearchResultsCount(null);
        setStatusFilter('all');
        setMinPrice('');
        setMaxPrice('');
        setFiltersVisible(false);
        setStatusFilter('all');
        setMinPrice('');
        setMaxPrice('');
        setFiltersVisible(false);
        const cleanup = pusherService.subscribeToAuction(slug, handleAuctionUpdate);
        return () => {
            cleanup();
            pusherService.disconnect();
        };
    }, [slug]);

    // Initialize countdownCompleted state when auction loads
    useEffect(() => {
        if (auction?.start_time) {
            const now = moment(getServerNow());
            const startTime = moment(auction.start_time);
            // If auction has already started, set countdownCompleted to true
            if (startTime.isBefore(now) || startTime.isSame(now)) {
                setCountdownCompleted(true);
            } else {
                setCountdownCompleted(false);
                // Reset the ref when auction changes and hasn't started yet
                countdownCompleteCalled.current = false;
            }
        } else {
            setCountdownCompleted(false);
            countdownCompleteCalled.current = false;
        }
    }, [auction]);

    const loadAuction = async () => {
        try {
            setLoading(true);
            const response = await auctionService.getAuction(slug);
            console.log('Auction API Response:', response);
            
            if (!response || !response.data) {
                throw new Error('Invalid response format from API');
            }

            const auctionData = response.data;
            console.log('Auction Data:', auctionData);
            
            // Ensure we have the required data
            if (!auctionData.id || !auctionData.title) {
                throw new Error('Missing required auction data');
            }

            setAuction(auctionData);
            
            // Set initial lots from auction data (first page)
            const initialLots = auctionData.lots || [];
            setLots(initialLots);
            
            // Check if there are more lots to load
            const totalLots = auctionData.lots_count || 0;
            setTotalLotsCount(totalLots);
            setHasMore(initialLots.length < totalLots);
            setCurrentPage(1);
            setSearchQuery(''); // Reset search when auction changes
            setIsSearching(false);
            setSearchResultsCount(null);
            setStatusFilter('all');
            setMinPrice('');
            setMaxPrice('');
            setFiltersVisible(false);
        } catch (error) {
            console.error('Error loading auction:', error);
            console.error('Error details:', {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status
            });
            
            // Don't show error message for 404, let the UI handle it
            if (error.response?.status !== 404) {
                message.error(error.response?.data?.message || 'Failed to load auction details');
            }
            
            setAuction(null);
            setLots([]);
        } finally {
            setLoading(false);
        }
    };

    const handleAuctionUpdate = (data) => {
        if (data.event === 'AuctionUpdated') {
            setAuction(prev => ({ ...prev, ...data.auction }));
            // Don't update lots here - let infinite scroll handle it
        }
    };

    // Build filter params
    const buildFilterParams = useCallback((page = 1) => {
        const params = {
            page: page,
            per_page: 12
        };

        // Add search query
        if (searchQuery.trim()) {
            params.search = searchQuery.trim();
        }

        // Add status filter - map "sold" to "closed" for backend
        if (statusFilter && statusFilter !== 'all') {
            params.status = statusFilter === 'sold' ? 'closed' : statusFilter;
        }

        // Add price filters
        if (minPrice && minPrice.trim() !== '') {
            params.min_price = parseFloat(minPrice);
        }

        if (maxPrice && maxPrice.trim() !== '') {
            params.max_price = parseFloat(maxPrice);
        }

        return params;
    }, [searchQuery, statusFilter, minPrice, maxPrice]);

    // Load more lots for infinite scroll
    const loadMoreLots = useCallback(async () => {
        if (!auction || loadingMore || !hasMore) return;

        try {
            setLoadingMore(true);
            const nextPage = currentPage + 1;
            const params = buildFilterParams(nextPage);

            const response = await auctionService.getLots(slug, params);

            if (response && response.data) {
                const newLots = response.data;
                const pagination = response.pagination;

                setLots(prev => [...prev, ...newLots]);
                setCurrentPage(nextPage);
                setHasMore(pagination?.has_more || false);
                
                // Update search results count
                if (pagination?.total !== undefined) {
                    setSearchResultsCount(pagination.total);
                }
            }
        } catch (error) {
            console.error('Error loading more lots:', error);
            message.error('Failed to load more lots');
        } finally {
            setLoadingMore(false);
        }
    }, [auction, slug, currentPage, hasMore, loadingMore, buildFilterParams]);

    // Perform backend search/filter
    const performSearch = useCallback(async (page = 1, customParams = null) => {
        if (!auction) return;

        try {
            setLoadingMore(true);
            const params = customParams || buildFilterParams(page);

            const response = await auctionService.getLots(slug, params);

            if (response && response.data) {
                const newLots = response.data;
                const pagination = response.pagination;

                if (page === 1) {
                    setLots(newLots);
                } else {
                    setLots(prev => [...prev, ...newLots]);
                }
                
                setCurrentPage(page);
                setHasMore(pagination?.has_more || false);
                setSearchResultsCount(pagination?.total || null);
            }
        } catch (error) {
            console.error('Error searching/filtering lots:', error);
            message.error('Failed to search lots');
        } finally {
            setLoadingMore(false);
        }
    }, [auction, slug, buildFilterParams]);

    // Check if any filters are active
    const hasActiveFilters = useCallback(() => {
        return searchQuery.trim() !== '' || 
               statusFilter !== 'all' || 
               minPrice.trim() !== '' || 
               maxPrice.trim() !== '';
    }, [searchQuery, statusFilter, minPrice, maxPrice]);

    // Handle search/filter on Enter key press or filter change
    const handleSearch = useCallback(() => {
        if (hasActiveFilters()) {
            setIsSearching(true);
            setLots([]); // Clear current lots
            setCurrentPage(1);
            setHasMore(true);
            performSearch(1);
        } else {
            // Clear all filters - reload initial lots
            setIsSearching(false);
            setSearchResultsCount(null);
            setCurrentPage(1);
            setHasMore(true);
            // Reload initial lots from auction data
            if (auction) {
                const initialLots = auction.lots || [];
                setLots(initialLots);
                const totalLots = auction.lots_count || 0;
                setHasMore(initialLots.length < totalLots);
            }
        }
    }, [searchQuery, statusFilter, minPrice, maxPrice, performSearch, auction]);

    // Handle Enter key press in search input
    const handleSearchKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSearch();
        }
    };

    // Clear search query only
    const handleClearSearch = () => {
        const newSearchQuery = '';
        setSearchQuery(newSearchQuery);
        // Check if other filters are active (without search)
        const otherFiltersActive = statusFilter !== 'all' || minPrice.trim() !== '' || maxPrice.trim() !== '';
        
        if (!otherFiltersActive) {
            // No filters active, reset to initial state
            setIsSearching(false);
            setSearchResultsCount(null);
            setCurrentPage(1);
            setHasMore(true);
            if (auction) {
                const initialLots = auction.lots || [];
                setLots(initialLots);
                const totalLots = auction.lots_count || 0;
                setHasMore(initialLots.length < totalLots);
            }
        } else {
            // Other filters are active, reapply filters without search
            setIsSearching(true);
            setLots([]);
            setCurrentPage(1);
            setHasMore(true);
            // Build params without search query
            const params = {
                page: 1,
                per_page: 12
            };
            if (statusFilter && statusFilter !== 'all') {
                params.status = statusFilter;
            }
            if (minPrice && minPrice.trim() !== '') {
                params.min_price = parseFloat(minPrice);
            }
            if (maxPrice && maxPrice.trim() !== '') {
                params.max_price = parseFloat(maxPrice);
            }
            performSearch(1, params);
        }
    };

    // Clear all filters
    const handleClearFilters = () => {
        setSearchQuery('');
        setStatusFilter('all');
        setMinPrice('');
        setMaxPrice('');
        setIsSearching(false);
        setSearchResultsCount(null);
        setCurrentPage(1);
        setHasMore(true);
        // Reload initial lots from auction data
        if (auction) {
            const initialLots = auction.lots || [];
            setLots(initialLots);
            const totalLots = auction.lots_count || 0;
            setHasMore(initialLots.length < totalLots);
        }
    };

    // Handle filter changes - triggers search
    const handleFilterChange = useCallback(() => {
        handleSearch();
    }, [handleSearch]);

    // Infinite scroll observer
    useEffect(() => {
        if (!hasMore || loadingMore || !lotsObserverRef.current) return;
        // Don't observe if searching and we have no results (nothing to scroll to)
        if (isSearching && lots.length === 0) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && hasMore && !loadingMore) {
                    loadMoreLots();
                }
            },
            {
                root: null,
                rootMargin: '100px',
                threshold: 0.1
            }
        );

        const currentRef = lotsObserverRef.current;
        observer.observe(currentRef);

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [hasMore, loadingMore, loadMoreLots, isSearching, lots.length]);

    const getStatusColor = (status) => {
        const colors = {
            draft: 'secondary',
            scheduled: 'info',
            active: 'success',
            live: 'success',
            completed: 'success',
            cancelled: 'danger'
        };
        return colors[status] || 'secondary';
    };

    const getStatusBadgeClass = (status) => {
        const color = getStatusColor(status);
        return `bg-${color}`;
    };

    const getDisplayStatus = (status) => {
        if (status?.toLowerCase() === 'closed') {
            return 'sold';
        }
        return status;
    };

    const handleToggleFavorite = async () => {
        if (!currentUser) {
            message.warning('Please login to add favorites');
            return;
        }

        // Optimistically update Redux state
        dispatch(toggleFavoriteAuction(auction.id));

        try {
            const response = await favoriteService.toggleFavoriteAuction(auction.id);
            //message.success(response.data.message);
        } catch (error) {
            console.error('Error toggling favorite:', error);
            // Revert the optimistic update on error
            dispatch(toggleFavoriteAuction(auction.id));
            message.error(error.response?.data?.message || 'Failed to update favorite status');
        }
    };

    const isFavorite = currentUser?.favorite_auctions?.includes(auction?.id);

    const handleToggleLotFavorite = async (lotId, event) => {
        event.stopPropagation(); // Prevent navigation when clicking favorite button
        
        if (!currentUser) {
            message.warning('Please login to add favorites');
            return;
        }

        // Optimistically update Redux state
        dispatch(toggleFavoriteLot(lotId));

        try {
            const response = await favoriteService.toggleFavoriteLot(lotId);
            //message.success(response.data.message);
        } catch (error) {
            console.error('Error toggling favorite:', error);
            // Revert the optimistic update on error
            dispatch(toggleFavoriteLot(lotId));
            message.error(error.response?.data?.message || 'Failed to update favorite status');
        }
    };

    const isLotFavorite = (lotId) => currentUser?.favorite_lots?.includes(lotId);

    // Show "Enter Auction" whenever there's still something to enter - both
    // while live/active AND while scheduled, so users can go wait in the
    // live-auction room before it starts. Only unavailable once completed
    // or cancelled.
    const isConnectToBidAvailable = () => {
        return auction?.status !== 'completed' && auction?.status !== 'cancelled';
    };

    // Generate Google Calendar URL
    const generateGoogleCalendarUrl = () => {
        if (!auction || !auction.start_time) {
            return null;
        }

        const startTime = moment(auction.start_time);
        // If end_time exists, use it; otherwise, add 2 hours to start_time as default duration
        const endTime = auction.end_time 
            ? moment(auction.end_time) 
            : startTime.clone().add(2, 'hours');

        // Format dates for Google Calendar (YYYYMMDDTHHmmssZ in UTC)
        const formatGoogleDate = (momentDate) => {
            return momentDate.utc().format('YYYYMMDDTHHmmss[Z]');
        };

        const startDateStr = formatGoogleDate(startTime);
        const endDateStr = formatGoogleDate(endTime);

        // Build the event title (don't encode here, URLSearchParams will handle it)
        const title = auction.title || 'Auction Event';
        const dates = `${startDateStr}/${endDateStr}`;
        
        // Build the event details with auction links
        const auctionUrl = `${window.location.origin}/auctions/${slug}`;
        const liveAuctionUrl = `${window.location.origin}/live-auctions/${slug}`;
        let details = `${title}\n\n`;
        
        if (auction.description) {
            details += `${auction.description}\n\n`;
        }
        
        if (auction.category?.name) {
            details += `Category: ${auction.category.name}\n`;
        }
        
        if (lots.length > 0) {
            details += `Total Lots: ${lots.length}\n`;
        }
        
        // Add the auction links
        details += `\nView Auction Details: ${auctionUrl}`;
        details += `\nJoin Live Auction: ${liveAuctionUrl}`;
        
        // Don't encode here, URLSearchParams will handle encoding
        const description = details;
        const location = auction.location || '';

        // Google Calendar URL - URLSearchParams will handle encoding automatically
        const baseUrl = 'https://calendar.google.com/calendar/render';
        const params = new URLSearchParams({
            action: 'TEMPLATE',
            text: title,
            dates: dates,
            details: description,
            location: location,
        });

        return `${baseUrl}?${params.toString()}`;
    };

    const handleAddToCalendar = () => {
        const calendarUrl = generateGoogleCalendarUrl();
        if (calendarUrl) {
            window.open(calendarUrl, '_blank');
            message.success('Opening Google Calendar...');
        } else {
            message.warning('Unable to add to calendar. Auction start time is missing.');
        }
    };

    // Check if auction start time is in the future
    const isAuctionUpcoming = () => {
        if (!auction?.start_time) return false;
        const now = moment(getServerNow());
        const startTime = moment(auction.start_time);
        return startTime.isAfter(now);
    };

    // Build breadcrumb items
    const buildBreadcrumbItems = () => {
        const items = [
            { label: 'Home', to: '/' },
            { label: 'Auctions', to: '/auctions' }
        ];

        if (auction?.category) {
            items.push({
                label: auction.category.name || 'Category',
                to: auction.category.slug ? `/category-results?category=${auction.category.slug}` : `/auctions?category=${auction.category.id}`
            });
        }

        if (auction) {
            items.push({
                label: auction.title || 'Auction Details',
                active: true
            });
        }

        return items;
    };


    const renderSkeleton = () => {
        const skeletonAnimation = {
            background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
            backgroundSize: '200% 100%',
            animation: 'loading 1.5s ease-in-out infinite'
        };
        
        return (
            <div className="auction-detail" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                {/* Breadcrumb Skeleton */}
                <div className="container-fluid px-2 px-lg-3" style={{ paddingTop: '16px', paddingBottom: '16px' }}>
                    <div style={{
                        height: '60px',
                        borderRadius: '12px',
                        ...skeletonAnimation
                    }}></div>
                </div>

                {/* Main Content Skeleton */}
                <div className="container-fluid px-2 px-lg-3" style={{ paddingTop: '16px', paddingBottom: '24px' }}>
                    <div className="row g-3">
                        {/* Left Column */}
                        <div className="col-lg-8">
                            <div className="d-flex flex-column gap-3">
                                {/* Images Section Skeleton */}
                                <div className="card border-0" style={{ 
                                    borderRadius: '16px', 
                                    overflow: 'hidden',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <div style={{
                                        width: '100%',
                                        height: '500px',
                                        ...skeletonAnimation
                                    }}></div>
                                </div>

                                {/* Description Section Skeleton */}
                                <div className="card border-0" style={{ 
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <div className="card-body p-4">
                                        <div className="d-flex align-items-center mb-3">
                                            <div style={{
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '8px',
                                                ...skeletonAnimation,
                                                marginRight: '12px'
                                            }}></div>
                                            <div style={{
                                                width: '150px',
                                                height: '24px',
                                                borderRadius: '4px',
                                                ...skeletonAnimation
                                            }}></div>
                                        </div>
                                        <div className="p-4 rounded-3" style={{ 
                                            backgroundColor: '#f8fafc', 
                                            border: '1px solid #e2e8f0'
                                        }}>
                                            <div style={{
                                                width: '100%',
                                                height: '16px',
                                                borderRadius: '4px',
                                                ...skeletonAnimation,
                                                marginBottom: '12px'
                                            }}></div>
                                            <div style={{
                                                width: '90%',
                                                height: '16px',
                                                borderRadius: '4px',
                                                ...skeletonAnimation,
                                                marginBottom: '12px'
                                            }}></div>
                                            <div style={{
                                                width: '85%',
                                                height: '16px',
                                                borderRadius: '4px',
                                                ...skeletonAnimation
                                            }}></div>
                                        </div>
                                    </div>
                                </div>

                                {/* Location Map Section Skeleton */}
                                <div className="card border-0" style={{ 
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    border: '1px solid #e2e8f0',
                                    overflow: 'hidden'
                                }}>
                                    <div className="card-body p-0">
                                        {/* Map Header Skeleton */}
                                        <div className="p-4 pb-3" style={{
                                            background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                                            borderBottom: '1px solid #e2e8f0'
                                        }}>
                                            <div className="d-flex align-items-center">
                                                <div style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '8px',
                                                    ...skeletonAnimation,
                                                    marginRight: '12px'
                                                }}></div>
                                                <div>
                                                    <div style={{
                                                        width: '120px',
                                                        height: '20px',
                                                        borderRadius: '4px',
                                                        ...skeletonAnimation,
                                                        marginBottom: '8px'
                                                    }}></div>
                                                    <div style={{
                                                        width: '200px',
                                                        height: '16px',
                                                        borderRadius: '4px',
                                                        ...skeletonAnimation
                                                    }}></div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Map Area Skeleton */}
                                        <div style={{
                                            width: '100%',
                                            height: '500px',
                                            ...skeletonAnimation
                                        }}></div>
                                        {/* Map Footer Skeleton */}
                                        <div className="p-4 pt-3" style={{
                                            background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                                            borderTop: '1px solid #e2e8f0'
                                        }}>
                                            <div style={{
                                                width: '150px',
                                                height: '16px',
                                                borderRadius: '4px',
                                                ...skeletonAnimation
                                            }}></div>
                                        </div>
                                    </div>
                                </div>

                                {/* Lots Section Skeleton */}
                                <div className="card border-0" style={{ 
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <div className="card-body p-4">
                                        <div className="d-flex align-items-center justify-content-between mb-4">
                                            <div className="d-flex align-items-center">
                                                <div style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '8px',
                                                    ...skeletonAnimation,
                                                    marginRight: '12px'
                                                }}></div>
                                                <div>
                                                    <div style={{
                                                        width: '100px',
                                                        height: '20px',
                                                        borderRadius: '4px',
                                                        ...skeletonAnimation,
                                                        marginBottom: '6px'
                                                    }}></div>
                                                    <div style={{
                                                        width: '180px',
                                                        height: '14px',
                                                        borderRadius: '4px',
                                                        ...skeletonAnimation
                                                    }}></div>
                                                </div>
                                            </div>
                                            <div style={{
                                                width: '40px',
                                                height: '24px',
                                                borderRadius: '8px',
                                                ...skeletonAnimation
                                            }}></div>
                                        </div>
                                        {/* Lots Grid Skeleton */}
                                        <div className="row g-3">
                                            {[1, 2, 3].map((item) => (
                                                <div key={item} className="col-md-6 col-lg-4">
                                                    <div className="card border-0 h-100" style={{
                                                        borderRadius: '12px',
                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                        border: '1px solid #e2e8f0'
                                                    }}>
                                                        <div style={{
                                                            width: '100%',
                                                            height: '200px',
                                                            borderTopLeftRadius: '12px',
                                                            borderTopRightRadius: '12px',
                                                            ...skeletonAnimation
                                                        }}></div>
                                                        <div className="card-body p-3">
                                                            <div style={{
                                                                width: '100%',
                                                                height: '18px',
                                                                borderRadius: '4px',
                                                                ...skeletonAnimation,
                                                                marginBottom: '8px'
                                                            }}></div>
                                                            <div style={{
                                                                width: '80%',
                                                                height: '14px',
                                                                borderRadius: '4px',
                                                                ...skeletonAnimation,
                                                                marginBottom: '12px'
                                                            }}></div>
                                                            <div className="d-flex justify-content-between">
                                                                <div style={{
                                                                    width: '80px',
                                                                    height: '40px',
                                                                    borderRadius: '4px',
                                                                    ...skeletonAnimation
                                                                }}></div>
                                                                <div style={{
                                                                    width: '60px',
                                                                    height: '40px',
                                                                    borderRadius: '4px',
                                                                    ...skeletonAnimation
                                                                }}></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Column */}
                        <div className="col-lg-4">
                            <div className="d-flex flex-column gap-3">
                                {/* Enter Auction Button Skeleton */}
                                <div className="card border-0" style={{ 
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    border: '1px solid #e2e8f0',
                                    zIndex: 10
                                }}>
                                    <div className="card-body p-4">
                                        <div style={{
                                            width: '100%',
                                            height: '56px',
                                            borderRadius: '12px',
                                            ...skeletonAnimation
                                        }}></div>
                                    </div>
                                </div>

                                {/* Auction Info Card Skeleton - Compact */}
                                <div className="card border-0" style={{ 
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    border: '1px solid #e2e8f0',
                                    zIndex: 9
                                }}>
                                    <div className="card-body p-3">
                                        <div className="row g-3">
                                            {[1, 2, 3, 4].map((item) => (
                                                <div key={item} className="col-6">
                                                    <div className="d-flex align-items-center">
                                                        <div style={{
                                                            width: '20px',
                                                            height: '20px',
                                                            borderRadius: '4px',
                                                            ...skeletonAnimation,
                                                            marginRight: '6px'
                                                        }}></div>
                                                        <div style={{ flex: 1 }}>
                                                            <div style={{
                                                                width: '50px',
                                                                height: '10px',
                                                                borderRadius: '4px',
                                                                ...skeletonAnimation,
                                                                marginBottom: '4px'
                                                            }}></div>
                                                            <div style={{
                                                                width: '40px',
                                                                height: '14px',
                                                                borderRadius: '4px',
                                                                ...skeletonAnimation
                                                            }}></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                {/* Overview Card Skeleton */}
                                <div className="card border-0" style={{ 
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    border: '1px solid #e2e8f0',
                                    zIndex: 9
                                }}>
                                    <div className="card-body p-4">
                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                            <div style={{
                                                width: '120px',
                                                height: '24px',
                                                borderRadius: '4px',
                                                ...skeletonAnimation
                                            }}></div>
                                        </div>

                                        {/* Start Date and Status Row Skeleton */}
                                        <div className="row g-2 mb-3">
                                            <div className="col-6">
                                                <div style={{
                                                    width: '100%',
                                                    height: '120px',
                                                    borderRadius: '12px',
                                                    ...skeletonAnimation
                                                }}></div>
                                            </div>
                                            <div className="col-6">
                                                <div style={{
                                                    width: '100%',
                                                    height: '120px',
                                                    borderRadius: '12px',
                                                    ...skeletonAnimation
                                                }}></div>
                                            </div>
                                        </div>

                                        {/* End Date Skeleton */}
                                        <div className="mb-3">
                                            <div style={{
                                                width: '100%',
                                                height: '100px',
                                                borderRadius: '12px',
                                                ...skeletonAnimation
                                            }}></div>
                                        </div>

                                        {/* Details Section Skeleton */}
                                        <div className="border-top pt-3 mt-3">
                                            {[1, 2].map((item) => (
                                                <div key={item} style={{
                                                    width: '100%',
                                                    height: '60px',
                                                    borderRadius: '8px',
                                                    ...skeletonAnimation,
                                                    marginBottom: '12px'
                                                }}></div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                {/* Company Information Skeleton */}
                                <div className="card border-0" style={{ 
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    border: '1px solid #e2e8f0',
                                    zIndex: 9
                                }}>
                                    <div className="card-body p-4">
                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                            <div className="d-flex align-items-center">
                                                <div style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '8px',
                                                    ...skeletonAnimation,
                                                    marginRight: '12px'
                                                }}></div>
                                                <div>
                                                    <div style={{
                                                        width: '100px',
                                                        height: '20px',
                                                        borderRadius: '4px',
                                                        ...skeletonAnimation,
                                                        marginBottom: '6px'
                                                    }}></div>
                                                    <div style={{
                                                        width: '150px',
                                                        height: '14px',
                                                        borderRadius: '4px',
                                                        ...skeletonAnimation
                                                    }}></div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Company Logo Skeleton */}
                                        <div className="d-flex flex-column align-items-center mb-3">
                                            <div style={{
                                                width: '80px',
                                                height: '80px',
                                                borderRadius: '50%',
                                                ...skeletonAnimation,
                                                marginBottom: '12px'
                                            }}></div>
                                            <div style={{
                                                width: '150px',
                                                height: '18px',
                                                borderRadius: '4px',
                                                ...skeletonAnimation,
                                                marginBottom: '8px'
                                            }}></div>
                                            <div style={{
                                                width: '200px',
                                                height: '14px',
                                                borderRadius: '4px',
                                                ...skeletonAnimation
                                            }}></div>
                                        </div>
                                        {/* Contact Info Skeleton */}
                                        <div className="d-flex flex-column gap-2 mb-3">
                                            {[1, 2, 3].map((item) => (
                                                <div key={item} style={{
                                                    width: '100%',
                                                    height: '48px',
                                                    borderRadius: '8px',
                                                    ...skeletonAnimation
                                                }}></div>
                                            ))}
                                        </div>
                                        {/* Button Skeleton */}
                                        <div style={{
                                            width: '100%',
                                            height: '44px',
                                            borderRadius: '10px',
                                            ...skeletonAnimation
                                        }}></div>
                                    </div>
                                </div>

                                {/* Agents Section Skeleton */}
                                <div className="card border-0" style={{ 
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    border: '1px solid #e2e8f0',
                                    zIndex: 9
                                }}>
                                    <div className="card-body p-4">
                                        <div className="d-flex align-items-center justify-content-between mb-4">
                                            <div className="d-flex align-items-center">
                                                <div style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '8px',
                                                    ...skeletonAnimation,
                                                    marginRight: '12px'
                                                }}></div>
                                                <div>
                                                    <div style={{
                                                        width: '140px',
                                                        height: '20px',
                                                        borderRadius: '4px',
                                                        ...skeletonAnimation,
                                                        marginBottom: '6px'
                                                    }}></div>
                                                    <div style={{
                                                        width: '180px',
                                                        height: '14px',
                                                        borderRadius: '4px',
                                                        ...skeletonAnimation
                                                    }}></div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Agents List Skeleton */}
                                        <div className="d-flex flex-column gap-3">
                                            {[1, 2].map((item) => (
                                                <div key={item} style={{
                                                    width: '100%',
                                                    height: '200px',
                                                    borderRadius: '12px',
                                                    ...skeletonAnimation
                                                }}></div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <style>{`
                    @keyframes loading {
                        0% {
                            background-position: 200% 0;
                        }
                        100% {
                            background-position: -200% 0;
                        }
                    }
                `}</style>
            </div>
        );
    };

    if (loading) {
        return renderSkeleton();
    }

    if (!auction) {
        return (
            <div className="container py-5">
                <div className="text-center">
                    <h3 className="text-muted">Auction not found</h3>
                    <button 
                        className="btn btn-primary mt-3"
                        onClick={() => navigate('/auctions')}
                    >
                        Browse Auctions
                    </button>
                                        </div>
                                    </div>
        );
    }

    return (
        <div className="auction-detail" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
            {/* Breadcrumb Navigation Section */}
            <Breadcrumb
                items={buildBreadcrumbItems()}
                backLink={{
                    to: '/auctions',
                    label: '← Back to Auctions'
                }}
                auction={auction}
                auctionSlug={slug}
                isFavorite={isFavorite}
                onToggleFavorite={handleToggleFavorite}
                onShareClick={() => setShareModalVisible(true)}
                onQRCodeClick={() => setQrModalVisible(true)}
            />

            {/* Main Content Area */}
            <div className="container-fluid px-2 px-lg-3" style={{ paddingTop: '16px', paddingBottom: '24px' }}>
                <div className="row g-3">
                    {/* Left Column - Images & Details */}
                    <div className="col-lg-8">
                        <div className="d-flex flex-column gap-3">
                            {/* Navigation Section */}
                            <div className="card border-0" style={{ 
                                background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)'
                            }}>
                                <div className="card-body p-3">
                                    <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2">
                                        {/* Navigation Buttons */}
                                        <div className="d-flex flex-wrap gap-3">
                                                <a
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        scrollToDescription();
                                                    }}
                                                    style={{
                                                        color: '#3b82f6',
                                                        fontSize: '14px',
                                                        textDecoration: 'none',
                                                        cursor: 'pointer',
                                                        border: 'none',
                                                        background: 'none',
                                                        padding: 0
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.textDecoration = 'underline';
                                                        e.currentTarget.style.color = '#2563eb';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.textDecoration = 'none';
                                                        e.currentTarget.style.color = '#3b82f6';
                                                    }}
                                                >
                                                    Info
                                                </a>
                                                {lots.length > 0 && (
                                                    <a
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            scrollToLots();
                                                        }}
                                                        style={{
                                                            color: '#3b82f6',
                                                            fontSize: '14px',
                                                            textDecoration: 'none',
                                                            cursor: 'pointer',
                                                            border: 'none',
                                                            background: 'none',
                                                            padding: 0
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.textDecoration = 'underline';
                                                            e.currentTarget.style.color = '#2563eb';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.textDecoration = 'none';
                                                            e.currentTarget.style.color = '#3b82f6';
                                                        }}
                                                    >
                                                        Lots {totalLotsCount > 0 ? `(${totalLotsCount})` : ''}
                                                    </a>
                                                )}
                                                {((auction.agents && auction.agents.length > 0) || auction.user) && (
                                                    <a
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setAgentsModalVisible(true);
                                                        }}
                                                        style={{
                                                            color: auction.is_private ? '#dc2626' : '#3b82f6',
                                                            fontSize: '14px',
                                                            textDecoration: 'none',
                                                            cursor: 'pointer',
                                                            border: 'none',
                                                            background: 'none',
                                                            padding: 0,
                                                            fontWeight: auction.is_private ? '600' : 'normal'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.textDecoration = 'underline';
                                                            e.currentTarget.style.color = auction.is_private ? '#b91c1c' : '#2563eb';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.textDecoration = 'none';
                                                            e.currentTarget.style.color = auction.is_private ? '#dc2626' : '#3b82f6';
                                                        }}
                                                    >
                                                        {auction.agents && auction.agents.length > 0 ? (
                                                            <>
                                                        <FaUsers className="me-1" style={{ fontSize: '11px' }} />
                                                        Agents ({auction.agents.length})
                                                            </>
                                                        ) : (
                                                            <>
                                                        <FaUser className="me-1" style={{ fontSize: '11px' }} />
                                                                Contact Owner
                                                            </>
                                                        )}
                                                    </a>
                                                )}
                                                {auction.company && (
                                                    <a
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setCompanyDrawerVisible(true);
                                                        }}
                                                        style={{
                                                            color: '#10b981',
                                                            fontSize: '14px',
                                                            textDecoration: 'none',
                                                            cursor: 'pointer',
                                                            border: 'none',
                                                            background: 'none',
                                                            padding: 0
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.textDecoration = 'underline';
                                                            e.currentTarget.style.color = '#059669';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.textDecoration = 'none';
                                                            e.currentTarget.style.color = '#10b981';
                                                        }}
                                                    >
                                                        <FaStore className="me-1" style={{ fontSize: '11px' }} />
                                                        Company
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            {/* Images Section */}
                            <div className="card border-0" style={{ 
                                borderRadius: '16px', 
                                overflow: 'hidden',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                border: '1px solid #e2e8f0',
                                position: 'relative'
                            }}>
                                <div className="card-body p-0" style={{ position: 'relative' }}>
                                    <ImageGallery
                                        images={auction?.images || []}
                                        title={auction?.title || ''}
                                        videoUrl={auction?.video_url}
                                        onVideoClick={() => setVideoModalVisible(true)}
                                        status={auction?.status}
                                        statusBadgeClass={getStatusBadgeClass(auction?.status)}
                                        isFavorite={isFavorite}
                                        onToggleFavorite={handleToggleFavorite}
                                    />
                                    {/* Countdown Overlay */}
                                    {auction && (
                                        <AuctionCountdown
                                            auction={auction}
                                            variant="overlay"
                                            onCountdownComplete={() => {
                                                // Only update local state - no server request
                                                // Use ref to ensure this is only called once
                                                if (!countdownCompleteCalled.current) {
                                                    countdownCompleteCalled.current = true;
                                                    setCountdownCompleted(true);
                                                }
                                            }}
                                        />
                                    )}
                                </div>
                            </div>

                            {/* Enter Auction - Mobile Only (before Overview) */}
                            <div className="d-block d-lg-none">
                                <ConnectToBidShareButtons
                                    auction={auction}
                                    slug={slug}
                                    onShareClick={() => setShareModalVisible(true)}
                                    showConnectToBid={true}
                                />
                            </div>

                            {/* Overview Card - Mobile Only (after gallery) */}
                            <div className="d-block d-lg-none">
                                <div className="card border-0" style={{ 
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    border: '1px solid #e2e8f0',
                                    zIndex: 9
                                }}>
                                    <div className="card-body p-4">
                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                            <h5 className="card-title mb-0 fw-bold" style={{ 
                                                fontSize: '20px', 
                                                color: '#1e293b',
                                                letterSpacing: '-0.3px'
                                            }}>
                                                <FaInfoCircle className="me-2" style={{ color: '#3b82f6' }} />
                                                Overview
                                            </h5>
                                            {auction.start_time && isAuctionUpcoming() && (
                                                <Tooltip title="Set Reminder - Add to Google Calendar">
                                                    <button
                                                        onClick={handleAddToCalendar}
                                                        className="btn btn-sm border-0"
                                                        style={{
                                                            backgroundColor: '#f8fafc',
                                                            color: '#3b82f6',
                                                            borderRadius: '8px',
                                                            padding: '6px 12px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '6px',
                                                            transition: 'all 0.2s ease',
                                                            border: '1px solid #e2e8f0'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.backgroundColor = '#eff6ff';
                                                            e.currentTarget.style.borderColor = '#93c5fd';
                                                            e.currentTarget.style.transform = 'translateY(-1px)';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.backgroundColor = '#f8fafc';
                                                            e.currentTarget.style.borderColor = '#e2e8f0';
                                                            e.currentTarget.style.transform = 'translateY(0)';
                                                        }}
                                                    >
                                                        <FaCalendar style={{ fontSize: '14px' }} />
                                                        <span style={{ fontSize: '12px', fontWeight: '600' }}>Set Reminder</span>
                                                    </button>
                                                </Tooltip>
                                            )}
                                        </div>

                                        {/* Info Grid - Start Date and Status in one row */}
                                        <div className="row g-2 mb-3">
                                            {/* Start Date */}
                                            {auction.start_time && (
                                                <div className="col-6">
                                                    <div className="p-3 rounded-3 h-100" style={{
                                                        background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                                                        border: 'none',
                                                        boxShadow: '0 4px 16px rgba(37, 99, 235, 0.25)'
                                                    }}>
                                                        <div className="d-flex align-items-center mb-2">
                                                            <div className="rounded-2 p-2" style={{
                                                                backgroundColor: 'rgba(255, 255, 255, 0.2)'
                                                            }}>
                                                                <FaClock style={{ fontSize: '16px', color: '#ffffff' }} />
                                                            </div>
                                                        </div>
                                                        <small className="text-white text-uppercase fw-semibold d-block mb-2" style={{ 
                                                            fontSize: '10px', 
                                                            letterSpacing: '0.8px',
                                                            opacity: 0.95
                                                        }}>
                                                            Start Date
                                                        </small>
                                                        <h6 className="mb-0 fw-bold text-white" style={{ 
                                                            fontSize: '18px', 
                                                            textShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                            letterSpacing: '-0.2px'
                                                        }}>
                                                            {moment(auction.start_time).format('MMM DD')}
                                                        </h6>
                                                        <p className="mb-0 text-white" style={{ 
                                                            fontSize: '12px', 
                                                            opacity: 0.9,
                                                            marginTop: '2px'
                                                        }}>
                                                            {moment(auction.start_time).format('hh:mm A')}
                                                        </p>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Status */}
                                            <div className="col-6">
                                                <div className={`p-3 rounded-3 h-100`} style={{
                                                    background: getStatusColor(auction.status) === 'success'
                                                        ? 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)'
                                                        : getStatusColor(auction.status) === 'danger'
                                                        ? 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)'
                                                        : getStatusColor(auction.status) === 'info'
                                                        ? 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)'
                                                        : 'linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)',
                                                    border: `2px solid ${getStatusColor(auction.status) === 'success' ? '#10b981' : getStatusColor(auction.status) === 'danger' ? '#ef4444' : getStatusColor(auction.status) === 'info' ? '#3b82f6' : '#cbd5e1'}`,
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                                                }}>
                                                    <div className="d-flex align-items-center mb-2">
                                                        <div className="rounded-2 p-2" style={{
                                                            backgroundColor: getStatusColor(auction.status) === 'success' 
                                                                ? 'rgba(16, 185, 129, 0.15)' 
                                                                : getStatusColor(auction.status) === 'danger'
                                                                ? 'rgba(239, 68, 68, 0.15)'
                                                                : getStatusColor(auction.status) === 'info'
                                                                ? 'rgba(59, 130, 246, 0.15)'
                                                                : 'rgba(148, 163, 184, 0.15)'
                                                        }}>
                                                            <FaCheckCircle style={{ 
                                                                fontSize: '16px',
                                                                color: getStatusColor(auction.status) === 'success' ? '#10b981' : getStatusColor(auction.status) === 'danger' ? '#ef4444' : getStatusColor(auction.status) === 'info' ? '#3b82f6' : '#64748b'
                                                            }} />
                                                        </div>
                                                    </div>
                                                    <small className={`text-uppercase fw-semibold d-block mb-2`} style={{ 
                                                        fontSize: '10px', 
                                                        letterSpacing: '0.8px',
                                                        color: getStatusColor(auction.status) === 'success' ? '#059669' : getStatusColor(auction.status) === 'danger' ? '#dc2626' : getStatusColor(auction.status) === 'info' ? '#2563eb' : '#64748b'
                                                    }}>
                                                        Status
                                                    </small>
                                                    <h6 className="mb-0 fw-bold text-capitalize" style={{
                                                        fontSize: '18px',
                                                        color: getStatusColor(auction.status) === 'success' ? '#047857' : getStatusColor(auction.status) === 'danger' ? '#b91c1c' : getStatusColor(auction.status) === 'info' ? '#1e40af' : '#334155',
                                                        letterSpacing: '-0.2px'
                                                    }}>
                                                        {auction.status}
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>

                                        {/* End Date */}
                                        {auction.end_time && (
                                            <div className="mb-3">
                                                <div className="p-3 rounded-3" style={{
                                                    background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                                                    border: '1px solid #e2e8f0',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                                                }}>
                                                    <div className="d-flex align-items-center mb-2">
                                                        <div className="bg-blue-50 rounded-2 p-2" style={{
                                                            backgroundColor: '#eff6ff'
                                                        }}>
                                                            <FaClock style={{ fontSize: '16px', color: '#3b82f6' }} />
                                                        </div>
                                                    </div>
                                                    <small className="text-uppercase fw-semibold d-block mb-2" style={{ 
                                                        fontSize: '10px', 
                                                        letterSpacing: '0.8px',
                                                        color: '#64748b'
                                                    }}>
                                                        End Date
                                                    </small>
                                                    <h6 className="mb-0 fw-bold" style={{ 
                                                        fontSize: '18px', 
                                                        color: '#1e293b',
                                                        letterSpacing: '-0.2px'
                                                    }}>
                                                        {moment(auction.end_time).format('MMM DD, YYYY')}
                                                    </h6>
                                                    <p className="mb-0" style={{ 
                                                        fontSize: '12px', 
                                                        color: '#64748b',
                                                        marginTop: '2px'
                                                    }}>
                                                        {moment(auction.end_time).format('hh:mm A')}
                                                    </p>
                                                </div>
                                            </div>
                                        )}

                                        {/* Details Section */}
                                        <div className="border-top pt-3 mt-3" style={{ borderColor: '#e2e8f0' }}>
                                            {/* Auction Type */}
                                            <div className="d-flex align-items-center mb-2 p-3 rounded-3" style={{ 
                                                backgroundColor: '#f8fafc',
                                                border: '1px solid #e2e8f0'
                                            }}>
                                                <div className="bg-blue-50 rounded-2 p-2 me-3" style={{
                                                    backgroundColor: '#eff6ff'
                                                }}>
                                                    <FaStore style={{ fontSize: '16px', color: '#3b82f6' }} />
                                                </div>
                                                <div className="flex-grow-1">
                                                    <small className="text-uppercase fw-semibold d-block mb-1" style={{ 
                                                        fontSize: '10px', 
                                                        letterSpacing: '0.8px',
                                                        color: '#64748b'
                                                    }}>
                                                        Auction Type
                                                    </small>
                                                    <span className="fw-semibold" style={{ 
                                                        fontSize: '15px', 
                                                        color: '#1e293b'
                                                    }}>
                                                        {auction.is_sequential ? 'Sequential' : 'Simultaneous'}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Visibility */}
                                            <div 
                                                className={`d-flex align-items-center justify-content-between p-3 rounded-3 ${auction.is_private ? 'private-auction-highlight' : ''}`}
                                                style={auction.is_private ? {
                                                    backgroundColor: '#fef2f2',
                                                    border: '1px solid #fca5a5',
                                                    animation: 'pulseGlow 3s ease-in-out infinite'
                                                } : {
                                                    backgroundColor: '#f8fafc',
                                                    border: '1px solid #e2e8f0'
                                                }}
                                            >
                                                <div className="d-flex align-items-center flex-grow-1">
                                                    <div 
                                                        className="rounded-2 p-2 me-3" 
                                                        style={auction.is_private ? {
                                                            backgroundColor: 'rgba(239, 68, 68, 0.15)',
                                                            animation: 'iconPulse 2s ease-in-out infinite'
                                                        } : {
                                                            backgroundColor: '#eff6ff'
                                                        }}
                                                    >
                                                        <FaGlobe style={{ 
                                                            fontSize: '16px', 
                                                            color: auction.is_private ? '#dc2626' : '#3b82f6'
                                                        }} />
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <small className="text-uppercase fw-semibold d-block mb-1" style={{ 
                                                            fontSize: '10px', 
                                                            letterSpacing: '0.8px',
                                                            color: auction.is_private ? '#991b1b' : '#64748b'
                                                        }}>
                                                            Visibility
                                                        </small>
                                                        <span className="fw-semibold" style={{ 
                                                            fontSize: '15px', 
                                                            color: auction.is_private ? '#dc2626' : '#1e293b',
                                                            animation: auction.is_private ? 'textPulse 2.5s ease-in-out infinite' : 'none'
                                                        }}>
                                                            {auction.is_private ? 'Private Auction' : 'Public'}
                                                        </span>
                                                    </div>
                                                </div>
                                                {auction.is_private && ((auction.agents && auction.agents.length > 0) || auction.user) && (
                                                    <button
                                                        onClick={() => setAgentsModalVisible(true)}
                                                        className="btn btn-sm ms-3"
                                                        style={{
                                                            backgroundColor: '#dc2626',
                                                            color: '#ffffff',
                                                            border: 'none',
                                                            borderRadius: '8px',
                                                            fontSize: '12px',
                                                            fontWeight: '600',
                                                            padding: '6px 12px',
                                                            whiteSpace: 'nowrap',
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.backgroundColor = '#b91c1c';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.backgroundColor = '#dc2626';
                                                        }}
                                                    >
                                                        {auction.agents && auction.agents.length > 0
                                                            ? auction.agents.length === 1 
                                                                ? 'Contact Agent' 
                                                                : 'Contact Agents'
                                                            : 'Contact Owner'
                                                        }
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Description Section */}
                            <div ref={descriptionRef} className="card border-0" style={{ 
                                borderRadius: '16px',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                border: '1px solid #e2e8f0'
                            }}>
                                <div className="card-body p-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="bg-blue-50 rounded-2 p-2 me-3" style={{
                                            backgroundColor: '#eff6ff'
                                        }}>
                                            <FaFileAlt style={{ fontSize: '18px', color: '#3b82f6' }} />
                                        </div>
                                        <h3 className="mb-0 fw-bold" style={{ 
                                            fontSize: '20px',
                                            color: '#1e293b',
                                            letterSpacing: '-0.3px'
                                        }}>
                                            Description
                                        </h3>
                                    </div>
                                    <div className="p-4 rounded-3" style={{ 
                                        backgroundColor: '#f8fafc', 
                                        border: '1px solid #e2e8f0',
                                        lineHeight: '1.8'
                                    }}>
                                        <p className="mb-0" style={{ 
                                                fontSize: '16px',
                                            color: '#475569',
                                            lineHeight: '1.8'
                                        }}>
                                            {auction.description || 'No description available.'}
                                        </p>
                                        </div>
                                </div>
                                </div>

                            {/* Terms & Conditions Section */}
                            {auction.terms_conditions && (
                                <div className="card border-0" style={{ 
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <div className="card-body p-4">
                                        <div className="d-flex align-items-center mb-3">
                                            <div className="bg-blue-50 rounded-2 p-2 me-3" style={{
                                                backgroundColor: '#eff6ff'
                                            }}>
                                                <FaFileAlt style={{ fontSize: '18px', color: '#3b82f6' }} />
                                            </div>
                                            <h3 className="mb-0 fw-bold" style={{ 
                                                fontSize: '20px',
                                                color: '#1e293b',
                                                letterSpacing: '-0.3px'
                                            }}>
                                                Terms & Conditions
                                            </h3>
                                        </div>
                                        <div className="p-4 rounded-3" style={{ 
                                            backgroundColor: '#f8fafc', 
                                            border: '1px solid #e2e8f0',
                                            lineHeight: '1.8'
                                        }}>
                                            <p className="mb-0" style={{ 
                                                fontSize: '16px',
                                                color: '#475569',
                                                lineHeight: '1.8',
                                                whiteSpace: 'pre-wrap'
                                            }}>
                                                {auction.terms_conditions}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Location Map */}
                            {auction.location && (
                                <div ref={locationRef} className="card border-0" style={{ 
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    border: '1px solid #e2e8f0',
                                    overflow: 'hidden'
                                }}>
                                    <div className="card-body p-0">
                                        {/* Map Header */}
                                        <div className="p-4 pb-3" style={{
                                            background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                                            borderBottom: '1px solid #e2e8f0'
                                        }}>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center">
                                                    <div className="bg-blue-50 rounded-2 p-2 me-3" style={{
                                                        backgroundColor: '#eff6ff'
                                                    }}>
                                                        <FaMapMarkerAlt style={{ fontSize: '18px', color: '#3b82f6' }} />
                                                    </div>
                                                    <div>
                                                        <h3 className="mb-0 fw-bold" style={{
                                                            fontSize: '20px',
                                                            color: '#1e293b',
                                                            letterSpacing: '-0.4px'
                                                        }}>
                                                            Location
                                                        </h3>
                                                        <p className="mb-0 mt-1" style={{
                                                            fontSize: '14px',
                                                            color: '#64748b',
                                                            fontWeight: '500'
                                                        }}>
                                                            {auction.location}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        {/* Leaflet Map */}
                                        <div className="p-4 pt-3" style={{
                                            background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                                            borderTop: '1px solid #e2e8f0'
                                        }}>
                                            <LeafletMap
                                                location={auction.location}
                                                height="500px"
                                                zoom={13}
                                                showOpenInMaps={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Right Column - Details */}
                    <div className={`col-lg-4 ${!isConnectToBidAvailable() ? 'auction-detail-right-column' : ''}`}>
                        <div className="d-flex flex-column gap-3">
                            {/* Enter Auction and Share Buttons - Desktop Only */}
                            <div className="d-none d-lg-block">
                                <ConnectToBidShareButtons
                                    auction={auction}
                                    slug={slug}
                                    onShareClick={() => setShareModalVisible(true)}
                                    showConnectToBid={true}
                                />
                            </div>

                            {/* Auction Info Card - Compact */}
                            <div className="card border-0" style={{ 
                                borderRadius: '16px',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                border: '1px solid #e2e8f0',
                                zIndex: 9
                            }}>
                                <div className="card-body p-3">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-3" >
                                        {auction.location && (
                                            <div className="d-flex align-items-center">
                                                <FaMapMarkerAlt style={{ fontSize: '14px', color: '#3b82f6', marginRight: '6px' }} />
                                                <div>
                                                    <small className="text-uppercase fw-semibold d-block" style={{ 
                                                        fontSize: '9px', 
                                                        letterSpacing: '0.8px',
                                                        color: '#64748b'
                                                    }}>
                                                        Location
                                                    </small>
                                                    <p className="mb-0 fw-semibold" style={{ 
                                                        fontSize: '12px', 
                                                        color: '#1e293b',
                                                        lineHeight: '1.2'
                                                    }}>
                                                        {auction.location}
                                                    </p>
                                                </div>
                                            </div>
                                        )}

                                        {auction.category && (
                                            <div className="d-flex align-items-center">
                                                <FaHashtag style={{ fontSize: '14px', color: '#3b82f6', marginRight: '6px' }} />
                                                <div>
                                                    <small className="text-uppercase fw-semibold d-block" style={{
                                                        fontSize: '9px',
                                                        letterSpacing: '0.8px',
                                                        color: '#64748b'
                                                    }}>
                                                        Category
                                                    </small>
                                                    <p
                                                        className="mb-0 fw-semibold"
                                                        style={{
                                                            fontSize: '12px',
                                                            color: '#1e293b',
                                                            lineHeight: '1.2',
                                                            cursor: 'pointer',
                                                            transition: 'color 0.2s ease'
                                                        }}
                                                        onClick={() => {
                                                            const categoryUrl = auction.category.slug
                                                                ? `/category-results?category=${auction.category.slug}`
                                                                : `/auctions?category=${auction.category.id}`;
                                                            navigate(categoryUrl);
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.color = '#3b82f6';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.color = '#1e293b';
                                                        }}
                                                    >
                                                        {auction.category.name || auction.category}
                                                    </p>
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>

                            {/* Overview Card - Desktop Only */}
                            <div className="d-none d-lg-block">
                                <div className="card border-0" style={{ 
                                borderRadius: '16px',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                border: '1px solid #e2e8f0',
                                zIndex: 9
                            }}>
                                <div className="card-body p-4">
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <h5 className="card-title mb-0 fw-bold" style={{ 
                                            fontSize: '20px', 
                                            color: '#1e293b',
                                            letterSpacing: '-0.3px'
                                        }}>
                                            <FaInfoCircle className="me-2" style={{ color: '#3b82f6' }} />
                                            Overview
                                        </h5>
                                        {auction.start_time && isAuctionUpcoming() && (
                                            <Tooltip title="Set Reminder - Add to Google Calendar">
                                                <button
                                                    onClick={handleAddToCalendar}
                                                    className="btn btn-sm border-0"
                                                    style={{
                                                        backgroundColor: '#f8fafc',
                                                        color: '#3b82f6',
                                                        borderRadius: '8px',
                                                        padding: '6px 12px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        transition: 'all 0.2s ease',
                                                        border: '1px solid #e2e8f0'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor = '#eff6ff';
                                                        e.currentTarget.style.borderColor = '#93c5fd';
                                                        e.currentTarget.style.transform = 'translateY(-1px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor = '#f8fafc';
                                                        e.currentTarget.style.borderColor = '#e2e8f0';
                                                        e.currentTarget.style.transform = 'translateY(0)';
                                                    }}
                                                >
                                                    <FaCalendar style={{ fontSize: '14px' }} />
                                                    <span style={{ fontSize: '12px', fontWeight: '600' }}>Set Reminder</span>
                                                </button>
                                            </Tooltip>
                                        )}
                                    </div>

                                    {/* Info Grid - Start Date and Status in one row */}
                                    <div className="row g-2 mb-3">
                                        {/* Start Date */}
                                        {auction.start_time && (
                                            <div className="col-6">
                                                <div className="p-3 rounded-3 h-100" style={{
                                                    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                                                    border: 'none',
                                                    boxShadow: '0 4px 16px rgba(37, 99, 235, 0.25)'
                                                }}>
                                                    <div className="d-flex align-items-center mb-2">
                                                        <div className="rounded-2 p-2" style={{
                                                            backgroundColor: 'rgba(255, 255, 255, 0.2)'
                                                        }}>
                                                            <FaClock style={{ fontSize: '16px', color: '#ffffff' }} />
                                                        </div>
                                                    </div>
                                                    <small className="text-white text-uppercase fw-semibold d-block mb-2" style={{ 
                                                        fontSize: '10px', 
                                                        letterSpacing: '0.8px',
                                                        opacity: 0.95
                                                    }}>
                                                        Start Date
                                                    </small>
                                                    <h6 className="mb-0 fw-bold text-white" style={{ 
                                                        fontSize: '18px', 
                                                        textShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                        letterSpacing: '-0.2px'
                                                    }}>
                                                        {moment(auction.start_time).format('MMM DD')}
                                                    </h6>
                                                    <p className="mb-0 text-white" style={{ 
                                                        fontSize: '12px', 
                                                        opacity: 0.9,
                                                        marginTop: '2px'
                                                    }}>
                                                        {moment(auction.start_time).format('hh:mm A')}
                                                    </p>
                                                </div>
                                            </div>
                                        )}

                                        {/* Status */}
                                        <div className="col-6">
                                            <div className={`p-3 rounded-3 h-100`} style={{
                                                background: getStatusColor(auction.status) === 'success'
                                                    ? 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)'
                                                    : getStatusColor(auction.status) === 'danger'
                                                    ? 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)'
                                                    : getStatusColor(auction.status) === 'info'
                                                    ? 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)'
                                                    : 'linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)',
                                                border: `2px solid ${getStatusColor(auction.status) === 'success' ? '#10b981' : getStatusColor(auction.status) === 'danger' ? '#ef4444' : getStatusColor(auction.status) === 'info' ? '#3b82f6' : '#cbd5e1'}`,
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                                            }}>
                                                <div className="d-flex align-items-center mb-2">
                                                    <div className="rounded-2 p-2" style={{
                                                        backgroundColor: getStatusColor(auction.status) === 'success' 
                                                            ? 'rgba(16, 185, 129, 0.15)' 
                                                            : getStatusColor(auction.status) === 'danger'
                                                            ? 'rgba(239, 68, 68, 0.15)'
                                                            : getStatusColor(auction.status) === 'info'
                                                            ? 'rgba(59, 130, 246, 0.15)'
                                                            : 'rgba(148, 163, 184, 0.15)'
                                                    }}>
                                                        <FaCheckCircle style={{ 
                                                            fontSize: '16px',
                                                            color: getStatusColor(auction.status) === 'success' ? '#10b981' : getStatusColor(auction.status) === 'danger' ? '#ef4444' : getStatusColor(auction.status) === 'info' ? '#3b82f6' : '#64748b'
                                                        }} />
                                                    </div>
                                                </div>
                                                <small className={`text-uppercase fw-semibold d-block mb-2`} style={{ 
                                                    fontSize: '10px', 
                                                    letterSpacing: '0.8px',
                                                    color: getStatusColor(auction.status) === 'success' ? '#059669' : getStatusColor(auction.status) === 'danger' ? '#dc2626' : getStatusColor(auction.status) === 'info' ? '#2563eb' : '#64748b'
                                                }}>
                                                    Status
                                                </small>
                                                <h6 className="mb-0 fw-bold text-capitalize" style={{
                                                    fontSize: '18px',
                                                    color: getStatusColor(auction.status) === 'success' ? '#047857' : getStatusColor(auction.status) === 'danger' ? '#b91c1c' : getStatusColor(auction.status) === 'info' ? '#1e40af' : '#334155',
                                                    letterSpacing: '-0.2px'
                                                }}>
                                                    {auction.status}
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    {/* End Date */}
                                    {auction.end_time && (
                                        <div className="mb-3">
                                            <div className="p-3 rounded-3" style={{
                                                background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                                                border: '1px solid #e2e8f0',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                                            }}>
                                                <div className="d-flex align-items-center mb-2">
                                                    <div className="bg-blue-50 rounded-2 p-2" style={{
                                                        backgroundColor: '#eff6ff'
                                                    }}>
                                                        <FaClock style={{ fontSize: '16px', color: '#3b82f6' }} />
                                                    </div>
                                                </div>
                                                <small className="text-uppercase fw-semibold d-block mb-2" style={{ 
                                                    fontSize: '10px', 
                                                    letterSpacing: '0.8px',
                                                    color: '#64748b'
                                                }}>
                                                    End Date
                                                </small>
                                                <h6 className="mb-0 fw-bold" style={{ 
                                                    fontSize: '18px', 
                                                    color: '#1e293b',
                                                    letterSpacing: '-0.2px'
                                                }}>
                                                    {moment(auction.end_time).format('MMM DD, YYYY')}
                                                </h6>
                                                <p className="mb-0" style={{ 
                                                    fontSize: '12px', 
                                                    color: '#64748b',
                                                    marginTop: '2px'
                                                }}>
                                                    {moment(auction.end_time).format('hh:mm A')}
                                                </p>
                                            </div>
                                        </div>
                                    )}

                                    {/* Details Section */}
                                    <div className="border-top pt-3 mt-3" style={{ borderColor: '#e2e8f0' }}>
                                        {/* Auction Type */}
                                        <div className="d-flex align-items-center mb-2 p-3 rounded-3" style={{ 
                                            backgroundColor: '#f8fafc',
                                            border: '1px solid #e2e8f0'
                                        }}>
                                            <div className="bg-blue-50 rounded-2 p-2 me-3" style={{
                                                backgroundColor: '#eff6ff'
                                            }}>
                                                <FaStore style={{ fontSize: '16px', color: '#3b82f6' }} />
                                            </div>
                                            <div className="flex-grow-1">
                                                <small className="text-uppercase fw-semibold d-block mb-1" style={{ 
                                                    fontSize: '10px', 
                                                    letterSpacing: '0.8px',
                                                    color: '#64748b'
                                                }}>
                                                    Auction Type
                                                </small>
                                                <span className="fw-semibold" style={{ 
                                                    fontSize: '15px', 
                                                    color: '#1e293b'
                                                }}>
                                                    {auction.is_sequential ? 'Sequential' : 'Simultaneous'}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Visibility */}
                                            <div 
                                                className={`d-flex align-items-center justify-content-between p-3 rounded-3 ${auction.is_private ? 'private-auction-highlight' : ''}`}
                                                style={auction.is_private ? {
                                                    backgroundColor: '#fef2f2',
                                                    border: '1px solid #fca5a5',
                                                    animation: 'pulseGlow 3s ease-in-out infinite'
                                                } : {
                                                    backgroundColor: '#f8fafc',
                                                    border: '1px solid #e2e8f0'
                                                }}
                                            >
                                            <div className="d-flex align-items-center flex-grow-1">
                                                    <div 
                                                        className="rounded-2 p-2 me-3" 
                                                        style={auction.is_private ? {
                                                            backgroundColor: 'rgba(239, 68, 68, 0.15)',
                                                            animation: 'iconPulse 2s ease-in-out infinite'
                                                        } : {
                                                            backgroundColor: '#eff6ff'
                                                        }}
                                                    >
                                                    <FaGlobe style={{ 
                                                        fontSize: '16px', 
                                                            color: auction.is_private ? '#dc2626' : '#3b82f6'
                                                    }} />
                                                </div>
                                                <div className="flex-grow-1">
                                                    <small className="text-uppercase fw-semibold d-block mb-1" style={{ 
                                                        fontSize: '10px', 
                                                        letterSpacing: '0.8px',
                                                            color: auction.is_private ? '#991b1b' : '#64748b'
                                                    }}>
                                                        Visibility
                                                    </small>
                                                    <span className="fw-semibold" style={{ 
                                                        fontSize: '15px', 
                                                            color: auction.is_private ? '#dc2626' : '#1e293b',
                                                            animation: auction.is_private ? 'textPulse 2.5s ease-in-out infinite' : 'none'
                                                    }}>
                                                            {auction.is_private ? 'Private Auction' : 'Public'}
                                                    </span>
                                                </div>
                                            </div>
                                                {auction.is_private && ((auction.agents && auction.agents.length > 0) || auction.user) && (
                                                <button
                                                        onClick={() => setAgentsModalVisible(true)}
                                                        className="btn btn-sm ms-3"
                                                    style={{
                                                            backgroundColor: '#dc2626',
                                                            color: '#ffffff',
                                                        border: 'none',
                                                        borderRadius: '8px',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        padding: '6px 12px',
                                                        whiteSpace: 'nowrap',
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                            e.currentTarget.style.backgroundColor = '#b91c1c';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                            e.currentTarget.style.backgroundColor = '#dc2626';
                                                    }}
                                                >
                                                    {auction.agents && auction.agents.length > 0
                                                            ? auction.agents.length === 1 
                                                                ? 'Contact Agent' 
                                                                : 'Contact Agents'
                                                            : 'Contact Owner'
                                                        }
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>

                            {/* Company Information Section */}
                            {auction.company && (
                                <div className="card border-0" style={{ 
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    border: '1px solid #e2e8f0',
                                    background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                                }}
                                onClick={() => setCompanyDrawerVisible(true)}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(59, 130, 246, 0.15)';
                                    e.currentTarget.style.borderColor = '#93c5fd';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
                                    e.currentTarget.style.borderColor = '#e2e8f0';
                                }}
                                >
                                    <div className="card-body p-4">
                                        {/* Header */}
                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                            <div className="d-flex align-items-center">
                                                <div className="bg-blue-50 rounded-2 p-2 me-3" style={{
                                                    backgroundColor: '#eff6ff'
                                                }}>
                                                    <FaStore style={{ fontSize: '20px', color: '#3b82f6' }} />
                                                </div>
                                                <div>
                                                    <h5 className="mb-0 fw-bold" style={{ 
                                                        color: '#1e293b', 
                                                        fontSize: '20px', 
                                                        letterSpacing: '-0.3px' 
                                                    }}>
                                                        Company
                                                    </h5>
                                                    <small className="text-muted" style={{ fontSize: '13px' }}>
                                                        View company profile
                                                    </small>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Company Logo and Name */}
                                        <div className="d-flex flex-column align-items-center mb-3">
                                            {auction.company.company_logo_url ? (
                                                <img
                                                    src={auction.company.company_logo_url.startsWith('http') 
                                                        ? auction.company.company_logo_url 
                                                        : env.BACKEND_URL + auction.company.company_logo_url}
                                                    alt={auction.company.company_name}
                                                    className="rounded-circle mb-3"
                                                    style={{
                                                        width: '80px',
                                                        height: '80px',
                                                        objectFit: 'cover',
                                                        border: '3px solid #e2e8f0',
                                                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.15)'
                                                    }}
                                                />
                                            ) : (
                                                <div
                                                    className="rounded-circle d-flex align-items-center justify-content-center text-white fw-bold mb-3"
                                                    style={{
                                                        width: '80px',
                                                        height: '80px',
                                                        background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                                                        border: '3px solid #e2e8f0',
                                                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.15)',
                                                        fontSize: '32px'
                                                    }}
                                                >
                                                    {auction.company.company_name?.charAt(0).toUpperCase() || 'C'}
                                                </div>
                                            )}
                                            <h6 className="mb-1 fw-bold text-center" style={{ 
                                                fontSize: '18px',
                                                color: '#1e293b',
                                                letterSpacing: '-0.3px'
                                            }}>
                                                {auction.company.company_name || 'Company'}
                                            </h6>
                                            {auction.company.short_tagline && (
                                                <p className="text-center mb-0" style={{ 
                                                    fontSize: '13px',
                                                    color: '#64748b',
                                                    fontWeight: '500'
                                                }}>
                                                    {auction.company.short_tagline}
                                                </p>
                                            )}
                                        </div>

                                        {/* Contact Information */}
                                        <div className="d-flex flex-column gap-2 mb-3">
                                            {auction.company.email_address && (
                                                <div className="d-flex align-items-center p-2 rounded-3" style={{ 
                                                    backgroundColor: '#f8fafc',
                                                    border: '1px solid #e2e8f0'
                                                }}>
                                                    <div className="me-2 d-flex align-items-center justify-content-center" style={{
                                                        width: '32px',
                                                        height: '32px',
                                                        borderRadius: '8px',
                                                        backgroundColor: '#dbeafe',
                                                        flexShrink: 0
                                                    }}>
                                                        <FaEnvelope style={{ fontSize: '13px', color: '#2563eb' }} />
                                                    </div>
                                                    <a 
                                                        href={`mailto:${auction.company.email_address}`}
                                                        className="text-decoration-none flex-grow-1"
                                                        style={{ 
                                                            color: '#475569',
                                                            fontSize: '13px',
                                                            fontWeight: '500'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.color = '#2563eb';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.color = '#475569';
                                                        }}
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        {auction.company.email_address}
                                                    </a>
                                                </div>
                                            )}
                                            {auction.company.phone_whatsapp && (
                                                <div className="d-flex align-items-center p-2 rounded-3" style={{ 
                                                    backgroundColor: '#f8fafc',
                                                    border: '1px solid #e2e8f0'
                                                }}>
                                                    <div className="me-2 d-flex align-items-center justify-content-center" style={{
                                                        width: '32px',
                                                        height: '32px',
                                                        borderRadius: '8px',
                                                        backgroundColor: '#dbeafe',
                                                        flexShrink: 0
                                                    }}>
                                                        <FaPhone style={{ fontSize: '13px', color: '#2563eb' }} />
                                                    </div>
                                                    <a 
                                                        href={`tel:${auction.company.phone_whatsapp}`}
                                                        className="text-decoration-none flex-grow-1"
                                                        style={{ 
                                                            color: '#475569',
                                                            fontSize: '13px',
                                                            fontWeight: '500'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.color = '#2563eb';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.color = '#475569';
                                                        }}
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        {auction.company.phone_whatsapp}
                                                    </a>
                                                </div>
                                            )}
                                            {auction.company.business_address && (
                                                <div className="d-flex align-items-center p-2 rounded-3" style={{ 
                                                    backgroundColor: '#f8fafc',
                                                    border: '1px solid #e2e8f0'
                                                }}>
                                                    <div className="me-2 d-flex align-items-center justify-content-center" style={{
                                                        width: '32px',
                                                        height: '32px',
                                                        borderRadius: '8px',
                                                        backgroundColor: '#dbeafe',
                                                        flexShrink: 0
                                                    }}>
                                                        <FaMapMarkerAlt style={{ fontSize: '13px', color: '#2563eb' }} />
                                                    </div>
                                                    <span style={{ 
                                                        color: '#475569',
                                                        fontSize: '13px',
                                                        fontWeight: '500'
                                                    }}>
                                                        {auction.company.business_address}
                                                    </span>
                                                </div>
                                            )}
                                        </div>

                                        {/* View Details Button */}
                                        <button
                                            className="btn w-100 fw-semibold"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setCompanyDrawerVisible(true);
                                            }}
                                            style={{
                                                borderRadius: '10px',
                                                backgroundColor: '#3b82f6',
                                                color: '#ffffff',
                                                border: 'none',
                                                padding: '10px 16px',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                boxShadow: '0 4px 12px rgba(59, 130, 246, 0.25)',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                e.currentTarget.style.boxShadow = '0 6px 20px rgba(59, 130, 246, 0.35)';
                                                e.currentTarget.style.backgroundColor = '#2563eb';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.25)';
                                                e.currentTarget.style.backgroundColor = '#3b82f6';
                                            }}
                                        >
                                            <FaInfoCircle className="me-2" />
                                            View Full Profile
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* Agents Section or User Section */}
                            <ContactAgentsOwner
                                agents={auction.agents}
                                user={auction.user}
                                isPrivate={auction.is_private}
                                onContactClick={(type, value) => {
                                    // Optional callback for tracking contact clicks
                                    console.log(`Contact ${type}:`, value);
                                                                        }}
                                                                    />
                                                                </div>
                    </div>
                </div>

                {/* Lots Section - Full Width */}
                <div className="lot-container" style={{ paddingTop: '24px', paddingBottom: '24px' }}>
                            <div ref={lotsRef} className="card border-0 lots-section-container" style={{ 
                                borderRadius: '16px',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                border: '1px solid #e2e8f0'
                            }}>

{isDesktop ? (
    <Affix offsetTop={-24}>
        <LotsHeader
            isSearching={isSearching}
            searchResultsCount={searchResultsCount}
            lots={lots}
            totalLotsCount={totalLotsCount}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            minPrice={minPrice}
            setMinPrice={setMinPrice}
            maxPrice={maxPrice}
            setMaxPrice={setMaxPrice}
            handleSearch={handleSearch}
            handleClearFilters={handleClearFilters}
        />
    </Affix>
) : (
    <LotsHeader
        isSearching={isSearching}
        searchResultsCount={searchResultsCount}
        lots={lots}
        totalLotsCount={totalLotsCount}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        minPrice={minPrice}
        setMinPrice={setMinPrice}
        maxPrice={maxPrice}
        setMaxPrice={setMaxPrice}
        handleSearch={handleSearch}
        handleClearFilters={handleClearFilters}
    />
)}

                                
                                {/* Content */}
                                <div style={{
                                    padding: '24px',
                                    paddingTop: '20px'
                                }}>
                                    {lots.length === 0 && !loadingMore ? (
                                        <div className="text-center py-5">
                                            <p className="text-muted mb-0">
                                                {isSearching && searchQuery.trim() ? 'No lots found' : 'No lots available'}
                                            </p>
                                            <small className="text-muted">
                                                {isSearching && searchQuery.trim() 
                                                    ? 'Try adjusting your search query or press Enter to search again' 
                                                    : 'This auction doesn\'t have any lots yet'
                                                }
                                            </small>
                                        </div>
                                    ) : (
                                        <div className="row g-3">
                                            {lots.map((lot) => (
                                                <div key={lot.id} className="col-md-6 col-lg-4 col-xl-3">
                                                    <div 
                                                        className="card border-0 h-100"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                            border: '1px solid #e2e8f0',
                                                            cursor: 'pointer',
                                                            transition: 'all 0.3s ease'
                                                        }}
                                                        onClick={() => navigate(`/auctions/${slug}/lots/${lot.slug}`)}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.transform = 'translateY(-4px)';
                                                            e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                                                            e.currentTarget.style.borderColor = '#93c5fd';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.transform = 'translateY(0)';
                                                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                                                            e.currentTarget.style.borderColor = '#e2e8f0';
                                                        }}
                                                    >
                                                        <div style={{ position: 'relative' }}>
                                                            {Array.isArray(lot.images) && lot.images.length > 0 ? (
                                                                <>
                                                                    <img
                                                                        alt={lot.title}
                                                                        src={`${env.BACKEND_STORAGE_URL}/${lot.images[0].path}`}
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '200px',
                                                                            objectFit: 'cover',
                                                                            borderTopLeftRadius: '12px',
                                                                            borderTopRightRadius: '12px',
                                                                            transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)'
                                                                        }}
                                                                        onError={(e) => {
                                                                            e.target.style.display = 'none';
                                                                            if (e.target.nextSibling) {
                                                                                e.target.nextSibling.style.display = 'flex';
                                                                            }
                                                                        }}
                                                                        onMouseOver={(e) => e.target.style.transform = 'scale(1.08)'}
                                                                        onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                                                                    />
                                                                    <div
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '200px',
                                                                            display: 'none',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                                                                            flexDirection: 'column',
                                                                            gap: '16px',
                                                                            borderTopLeftRadius: '12px',
                                                                            borderTopRightRadius: '12px'
                                                                        }}
                                                                    >
                                                                        <div style={{
                                                                            width: '80px',
                                                                            height: '80px',
                                                                            borderRadius: '50%',
                                                                            background: 'rgba(255, 255, 255, 0.2)',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            color: 'white',
                                                                            fontSize: '32px',
                                                                            fontWeight: 'bold',
                                                                            backdropFilter: 'blur(10px)'
                                                                        }}>
                                                                            M
                                                                        </div>
                                                                        <div style={{ 
                                                                            fontSize: '14px', 
                                                                            textAlign: 'center',
                                                                            color: 'rgba(255, 255, 255, 0.9)',
                                                                            fontWeight: 500
                                                                        }}>
                                                                            Maveshibids
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <div style={{
                                                                    width: '100%',
                                                                    height: '200px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                                                                    flexDirection: 'column',
                                                                    gap: '16px',
                                                                    borderTopLeftRadius: '12px',
                                                                    borderTopRightRadius: '12px'
                                                                }}>
                                                                    <div style={{
                                                                        width: '80px',
                                                                        height: '80px',
                                                                        borderRadius: '50%',
                                                                        background: 'rgba(255, 255, 255, 0.2)',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        color: 'white',
                                                                        fontSize: '32px',
                                                                        fontWeight: 'bold',
                                                                        backdropFilter: 'blur(10px)'
                                                                    }}>
                                                                        M
                                                                    </div>
                                                                    <div style={{ 
                                                                        fontSize: '14px', 
                                                                        textAlign: 'center',
                                                                        color: 'rgba(255, 255, 255, 0.9)',
                                                                        fontWeight: 500
                                                                    }}>
                                                                        Maveshibids
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {/* Favorite Button - Top Left (Circular) */}
                                                            <button
                                                                className="btn p-0 border-0 position-absolute"
                                                                onClick={(e) => handleToggleLotFavorite(lot.id, e)}
                                                                style={{
                                                                    top: '8px',
                                                                    left: '8px',
                                                                    width: '36px',
                                                                    height: '36px',
                                                                    borderRadius: '50%',
                                                                    backgroundColor: isLotFavorite(lot.id) ? '#fef2f2' : 'rgba(255, 255, 255, 0.9)',
                                                                    border: `1px solid ${isLotFavorite(lot.id) ? '#fecaca' : 'rgba(226, 232, 240, 0.8)'}`,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    color: isLotFavorite(lot.id) ? '#ef4444' : '#475569',
                                                                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                                    zIndex: 3,
                                                                    backdropFilter: 'blur(4px)'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.currentTarget.style.backgroundColor = isLotFavorite(lot.id) ? '#fee2e2' : 'rgba(255, 255, 255, 1)';
                                                                    e.currentTarget.style.borderColor = isLotFavorite(lot.id) ? '#fca5a5' : '#cbd5e1';
                                                                    e.currentTarget.style.transform = 'scale(1.1)';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.currentTarget.style.backgroundColor = isLotFavorite(lot.id) ? '#fef2f2' : 'rgba(255, 255, 255, 0.9)';
                                                                    e.currentTarget.style.borderColor = isLotFavorite(lot.id) ? '#fecaca' : 'rgba(226, 232, 240, 0.8)';
                                                                    e.currentTarget.style.transform = 'scale(1)';
                                                                }}
                                                                title={isLotFavorite(lot.id) ? 'Remove from favorites' : 'Add to favorites'}
                                                            >
                                                                {isLotFavorite(lot.id) ? (
                                                                    <FaHeart style={{ fontSize: '14px' }} />
                                                                ) : (
                                                                    <FaRegHeart style={{ fontSize: '14px' }} />
                                                                )}
                                                            </button>
                                                            {/* Featured Badge - Bottom Left */}
                                                            {lot.is_featured && (
                                                                <div style={{
                                                                    position: 'absolute',
                                                                    bottom: '8px',
                                                                    left: '8px',
                                                                    zIndex: 3,
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    gap: '3px',
                                                                    background: 'linear-gradient(135deg, #ffd700 0%, #ffed4e 50%, #ffd700 100%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'shimmer 3s ease-in-out infinite',
                                                                    color: '#1f2937',
                                                                    padding: '3px 8px',
                                                                    borderRadius: '10px',
                                                                    fontSize: '9px',
                                                                    fontWeight: 700,
                                                                    boxShadow: '0 2px 6px rgba(255, 215, 0, 0.4), 0 1px 2px rgba(0, 0, 0, 0.2)',
                                                                    border: '1.5px solid rgba(255, 255, 255, 0.5)',
                                                                    textTransform: 'uppercase',
                                                                    letterSpacing: '0.3px'
                                                                }}>
                                                                    <span style={{
                                                                        display: 'inline-block',
                                                                        fontSize: '10px',
                                                                        animation: 'pulse 2s ease-in-out infinite'
                                                                    }}>⭐</span>
                                                                    <span>Featured</span>
                                                                </div>
                                                            )}
                                                            {lot.status && (
                                                                <span className={`badge position-absolute top-0 end-0 m-2 ${getStatusBadgeClass(lot.status)}`} style={{ 
                                                                    fontSize: '10px',
                                                                    fontWeight: '600',
                                                                    zIndex: 2
                                                                }}>
                                                                    {getDisplayStatus(lot.status).toUpperCase()}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="card-body p-3">
                                                            <h6 className="fw-bold mb-2" style={{ 
                                                                fontSize: '16px',
                                                                color: '#1e293b',
                                                                display: '-webkit-box',
                                                                WebkitLineClamp: 2,
                                                                WebkitBoxOrient: 'vertical',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                lineHeight: '1.4'
                                                            }}>
                                                                {lot.title ? lot.title.charAt(0).toUpperCase() + lot.title.slice(1) : 'Untitled Lot'}
                                                            </h6>
                                                            {lot.description && (
                                                                <p className="text-muted mb-2" style={{ 
                                                                    fontSize: '13px',
                                                                    display: '-webkit-box',
                                                                    WebkitLineClamp: 2,
                                                                    WebkitBoxOrient: 'vertical',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis'
                                                                }}>
                                                                    {lot.description}
                                                                </p>
                                                            )}
                                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                                <div>
                                                                    <small className="text-muted d-block" style={{ fontSize: '10px' }}>Starting Price</small>
                                                                    <span className="fw-bold" style={{ fontSize: '16px', color: '#3b82f6' }}>
                                                                        {formatCurrency(lot.starting_price || 0)}
                                                                    </span>
                                                                </div>
                                                                <div className="text-end">
                                                                    <small className="text-muted d-block" style={{ fontSize: '10px' }}>Quantity</small>
                                                                    <span className="fw-bold" style={{ fontSize: '16px', color: '#64748b' }}>
                                                                        {lot.quantity || 1}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            
                                            {/* Skeleton Cards while Loading More */}
                                            {loadingMore && (
                                                <>
                                                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((skeletonIndex) => (
                                                        <div key={`skeleton-${skeletonIndex}`} className="col-md-6 col-lg-4 col-xl-3">
                                                            <div 
                                                                className="card border-0 h-100"
                                                                style={{
                                                                    borderRadius: '12px',
                                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                                    border: '1px solid #e2e8f0',
                                                                    overflow: 'hidden'
                                                                }}
                                                            >
                                                                {/* Image Skeleton */}
                                                                <div 
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '200px',
                                                                        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                        backgroundSize: '200% 100%',
                                                                        animation: 'skeletonLoading 1.5s ease-in-out infinite'
                                                                    }}
                                                                />
                                                                
                                                                {/* Content Skeleton */}
                                                                <div className="card-body p-3">
                                                                    {/* Title Skeleton */}
                                                                    <div 
                                                                        style={{
                                                                            width: '90%',
                                                                            height: '18px',
                                                                            borderRadius: '4px',
                                                                            background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                            backgroundSize: '200% 100%',
                                                                            animation: 'skeletonLoading 1.5s ease-in-out infinite',
                                                                            marginBottom: '12px'
                                                                        }}
                                                                    />
                                                                    <div 
                                                                        style={{
                                                                            width: '70%',
                                                                            height: '18px',
                                                                            borderRadius: '4px',
                                                                            background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                            backgroundSize: '200% 100%',
                                                                            animation: 'skeletonLoading 1.5s ease-in-out infinite',
                                                                            marginBottom: '12px'
                                                                        }}
                                                                    />
                                                                    
                                                                    {/* Description Skeleton */}
                                                                    <div 
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '14px',
                                                                            borderRadius: '4px',
                                                                            background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                            backgroundSize: '200% 100%',
                                                                            animation: 'skeletonLoading 1.5s ease-in-out infinite',
                                                                            marginBottom: '8px'
                                                                        }}
                                                                    />
                                                                    <div 
                                                                        style={{
                                                                            width: '85%',
                                                                            height: '14px',
                                                                            borderRadius: '4px',
                                                                            background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                            backgroundSize: '200% 100%',
                                                                            animation: 'skeletonLoading 1.5s ease-in-out infinite',
                                                                            marginBottom: '16px'
                                                                        }}
                                                                    />
                                                                    
                                                                    {/* Price and Quantity Skeleton */}
                                                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                                                        <div style={{ flex: 1 }}>
                                                                            <div 
                                                                                style={{
                                                                                    width: '60px',
                                                                                    height: '10px',
                                                                                    borderRadius: '4px',
                                                                                    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                                    backgroundSize: '200% 100%',
                                                                                    animation: 'skeletonLoading 1.5s ease-in-out infinite',
                                                                                    marginBottom: '6px'
                                                                                }}
                                                                            />
                                                                            <div 
                                                                                style={{
                                                                                    width: '80px',
                                                                                    height: '16px',
                                                                                    borderRadius: '4px',
                                                                                    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                                    backgroundSize: '200% 100%',
                                                                                    animation: 'skeletonLoading 1.5s ease-in-out infinite'
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div style={{ flex: 1, textAlign: 'right' }}>
                                                                            <div 
                                                                                style={{
                                                                                    width: '50px',
                                                                                    height: '10px',
                                                                                    borderRadius: '4px',
                                                                                    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                                    backgroundSize: '200% 100%',
                                                                                    animation: 'skeletonLoading 1.5s ease-in-out infinite',
                                                                                    marginBottom: '6px',
                                                                                    marginLeft: 'auto'
                                                                                }}
                                                                            />
                                                                            <div 
                                                                                style={{
                                                                                    width: '40px',
                                                                                    height: '16px',
                                                                                    borderRadius: '4px',
                                                                                    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                                    backgroundSize: '200% 100%',
                                                                                    animation: 'skeletonLoading 1.5s ease-in-out infinite',
                                                                                    marginLeft: 'auto'
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </>
                                            )}
                                        </div>
                                    )}
                                    
                                    {/* Infinite Scroll Observer */}
                                    {hasMore && (
                                        <div 
                                            ref={lotsObserverRef}
                                            style={{
                                                height: '50px',
                                                marginTop: '20px'
                                            }}
                                        />
                                    )}
                                    
                                    {!hasMore && lots.length > 0 && (
                                        <div className="text-center py-4">
                                            <small className="text-muted">
                                                {isSearching && searchResultsCount !== null
                                                    ? `Showing all ${lots.length} of ${searchResultsCount} ${searchResultsCount === 1 ? 'result' : 'results'}`
                                                    : 'All lots loaded'
                                                }
                                            </small>
                                        </div>
                                    )}
                                    
                                    {/* Prominent Loading Overlay */}
                                    {loadingMore && (
                                        <>
                                            {/* Backdrop */}
                                            <div 
                                                style={{
                                                    position: 'fixed',
                                                    top: 0,
                                                    left: 0,
                                                    right: 0,
                                                    bottom: 0,
                                                    zIndex: 999,
                                                    animation: 'fadeIn 0.2s ease-out'
                                                }}
                                            />
                                            {/* Loading Card */}
                                            <div 
                                                style={{
                                                    position: 'fixed',
                                                    bottom: '30px',
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    zIndex: 1000,
                                                    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                                                    padding: '20px 32px',
                                                    borderRadius: '16px',
                                                    boxShadow: '0 12px 48px rgba(59, 130, 246, 0.4), 0 4px 16px rgba(0, 0, 0, 0.2)',
                                                    border: '2px solid rgba(255, 255, 255, 0.2)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '16px',
                                                    minWidth: '280px',
                                                    justifyContent: 'center',
                                                    animation: 'slideUpFadeInPulse 0.4s ease-out forwards, loadingPulse 2s ease-in-out infinite 0.4s'
                                                }}
                                            >
                                                <div 
                                                    className="spinner-border" 
                                                    role="status" 
                                                    style={{ 
                                                        width: '32px', 
                                                        height: '32px',
                                                        borderWidth: '4px',
                                                        borderColor: 'rgba(255, 255, 255, 0.3)',
                                                        borderTopColor: '#ffffff',
                                                        animation: 'spin 0.8s linear infinite'
                                                    }}
                                                >
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                                <span style={{ 
                                                    fontSize: '16px', 
                                                    fontWeight: '700',
                                                    color: '#ffffff',
                                                    letterSpacing: '0.3px',
                                                    textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
                                                }}>
                                                    Loading more lots...
                                                </span>
                                            </div>
                                        </>
                                    )}
                                                                </div>
                    </div>
                </div>

                {/* Featured Auctions Section */}
                <div className="container-fluid px-2 px-lg-3" style={{ paddingTop: '24px', paddingBottom: '24px' }}>
                    <FeaturedActiveAuctions
                        limit={6}
                        showViewAll={false}
                        category={auction?.category?.name || null}
                        excludeAuctionId={auction?.id || null}
                        hideIfEmpty={true}
                    />
                </div>
            </div>

            {/* Video Preview Modal */}
            {auction.video_url && (
                <VideoPreviewModal
                    visible={videoModalVisible}
                    onClose={() => setVideoModalVisible(false)}
                    videoUrl={auction.video_url}
                    title="Auction Promotional Video"
                    width={900}
                    height={500}
                />
            )}

            {/* Company Drawer */}
            {auction.company && (
                <CompanyDrawer
                    visible={companyDrawerVisible}
                    onClose={() => setCompanyDrawerVisible(false)}
                    companyData={auction.company}
                    userId={auction.user_id}
                />
            )}

            {/* Share Auction Modal */}
            {auction && (
                <ShareAuctionModal
                    visible={shareModalVisible}
                    onClose={() => setShareModalVisible(false)}
                    auction={auction}
                />
            )}

            {/* QR Code Modal */}
            {auction && (
                <AuctionQRCodeModal
                    visible={qrModalVisible}
                    onClose={() => setQrModalVisible(false)}
                    auction={auction}
                />
            )}

            {/* Agents Modal or User Modal */}
            {auction && ((auction.agents && auction.agents.length > 0) || auction.user) && (
                <Modal
                    title={
                        <div className="d-flex align-items-center">
                            {auction.agents && auction.agents.length > 0 ? (
                                <>
                                    <FaUsers className="me-2" style={{ color: '#3b82f6', fontSize: '20px' }} />
                                    <span style={{ fontSize: '18px', fontWeight: '600' }}>Contact Agents</span>
                                    <span className="ms-2 text-muted" style={{ fontSize: '14px', fontWeight: 'normal' }}>
                                ({auction.agents.length} {auction.agents.length === 1 ? 'agent' : 'agents'})
                            </span>
                                </>
                            ) : (
                                <>
                                    <FaUser className="me-2" style={{ color: '#3b82f6', fontSize: '20px' }} />
                                    <span style={{ fontSize: '18px', fontWeight: '600' }}>Contact Owner</span>
                                </>
                            )}
                        </div>
                    }
                    open={agentsModalVisible}
                    onCancel={() => setAgentsModalVisible(false)}
                    footer={null}
                    width={600}
                    style={{ top: 20 }}
                    bodyStyle={{ 
                        maxHeight: '90vh', 
                        overflowY: 'auto',
                        padding: '20px',
                        scrollbarWidth: 'none', /* Firefox */
                        msOverflowStyle: 'none' /* IE and Edge */
                    }}
                    className="hide-scrollbar"
                >
                    <ContactAgentsOwner
                        agents={auction.agents}
                        user={auction.user}
                        isPrivate={auction.is_private}
                        onContactClick={(type, value) => {
                            // Optional callback for tracking contact clicks
                            console.log(`Contact ${type}:`, value);
                                                            }}
                    />
                </Modal>
            )}

            {/* CSS Animations for Private Auction Highlighting */}
            <style>{`
                .hide-scrollbar::-webkit-scrollbar {
                    display: none; /* Chrome, Safari, Opera */
                }

                @keyframes pulseGlow {
                    0%, 100% {
                        box-shadow: 0 2px 8px rgba(239, 68, 68, 0.2);
                        border-color: #fca5a5;
                    }
                    50% {
                        box-shadow: 0 4px 16px rgba(239, 68, 68, 0.4);
                        border-color: #ef4444;
                    }
                }

                @keyframes shimmer {
                    0%, 100% {
                        background-position: 0% 50%;
                    }
                    50% {
                        background-position: 100% 50%;
                    }
                }

                @keyframes pulse {
                    0%, 100% {
                        transform: scale(1);
                        opacity: 1;
                    }
                    50% {
                        transform: scale(1.2);
                        opacity: 0.8;
                    }
                }

                @keyframes iconPulse {
                    0%, 100% {
                        transform: scale(1);
                        opacity: 1;
                    }
                    50% {
                        transform: scale(1.05);
                        opacity: 0.95;
                    }
                }

                @keyframes textPulse {
                    0%, 100% {
                        opacity: 1;
                    }
                    50% {
                        opacity: 0.9;
                    }
                }

                @keyframes slideUpFadeIn {
                    0% {
                        transform: translateX(-50%) translateY(20px);
                        opacity: 0;
                    }
                    100% {
                        transform: translateX(-50%) translateY(0);
                        opacity: 1;
                    }
                }

                @keyframes slideUpFadeInPulse {
                    0% {
                        transform: translateX(-50%) translateY(30px) scale(0.9);
                        opacity: 0;
                    }
                    50% {
                        transform: translateX(-50%) translateY(-5px) scale(1.02);
                    }
                    100% {
                        transform: translateX(-50%) translateY(0) scale(1);
                        opacity: 1;
                    }
                }

                @keyframes fadeIn {
                    0% {
                        opacity: 0;
                    }
                    100% {
                        opacity: 1;
                    }
                }

                @keyframes spin {
                    0% {
                        transform: rotate(0deg);
                    }
                    100% {
                        transform: rotate(360deg);
                    }
                }

                @keyframes loadingPulse {
                    0%, 100% {
                        box-shadow: 0 12px 48px rgba(59, 130, 246, 0.4), 0 4px 16px rgba(0, 0, 0, 0.2);
                    }
                    50% {
                        box-shadow: 0 16px 64px rgba(59, 130, 246, 0.6), 0 6px 24px rgba(0, 0, 0, 0.3);
                    }
                }

                @keyframes skeletonLoading {
                    0% {
                        background-position: 200% 0;
                    }
                    100% {
                        background-position: -200% 0;
                    }
                }

                @keyframes blink {
                    0%, 100% {
                        opacity: 1;
                        transform: scale(1);
                    }
                    50% {
                        opacity: 0.5;
                        transform: scale(0.9);
                    }
                }

                .private-auction-highlight {
                    animation: pulseGlow 2s ease-in-out infinite;
                }
            `}</style>
        </div>
    );
};

export default AuctionDetail; 